import { FADE_THRESHOLD, FRESHNESS_CAP, FRESHNESS_RATE, QUICK_WIN_BOOST } from './constants.js';
import { computeTemperature, daysBetween } from './curve.js';
/**
 * Scores an individual item for surfacing priority.
 * Temperature-dominant with effort and freshness modifiers.
 */
export function scoreItem(item, engagementLevel, now) {
    const temperature = computeTemperature(item.curve, item.createdAt, now);
    // After a gap, boost quick items to build momentum
    const effortBonus = engagementLevel !== 'daily' && item.effort === 'quick' ? QUICK_WIN_BOOST : 0;
    // Items not surfaced recently get a gentle nudge
    const freshnessBonus = item.lastSurfacedAt
        ? Math.min(daysBetween(item.lastSurfacedAt, now) * FRESHNESS_RATE, FRESHNESS_CAP)
        : 0;
    const total = temperature + effortBonus + freshnessBonus;
    return { temperature, effortBonus, freshnessBonus, total };
}
/**
 * Builds the surfacing queue from active items.
 * Two tiers: active items above fade threshold, then fading items.
 */
export function buildQueue(items, engagementLevel, now) {
    const scored = items
        .filter(i => i.status === 'active')
        .map(item => {
        const temp = computeTemperature(item.curve, item.createdAt, now);
        const fading = temp < FADE_THRESHOLD;
        const factors = fading ? null : scoreItem(item, engagementLevel, now);
        return { item, temperature: temp, fading, factors };
    });
    const active = scored
        .filter(s => !s.fading)
        .sort((a, b) => (b.factors?.total ?? 0) - (a.factors?.total ?? 0));
    const fading = scored.filter(s => s.fading).sort((a, b) => a.temperature - b.temperature); // coldest first — last chance
    return [...active, ...fading].map((s, i) => ({ ...s, queuePosition: i }));
}
//# sourceMappingURL=surfacing.js.map